import { useEffect } from 'react';
import { api } from '../../lib/api';

// Having Nexo open counts as being here, even in the background while you work in other apps:
// people show as offline only when they close it (the realtime connection drops). "Away" is one
// flag per user, though, and older desktop versions still set it after 10 idle minutes inside the
// app: every open copy clears it now and then, so the device in use always wins.
const REASSERT_EVERY = 2 * 60_000;

/** Keeps the user "here" (not away) while the app is open. */
export function useIdlePresence(): void {
  useEffect(() => {
    const here = () => void api.users.setAway(false).catch(() => undefined);
    here();
    const timer = setInterval(here, REASSERT_EVERY);
    document.addEventListener('visibilitychange', here);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', here);
    };
  }, []);
}
